import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ContentStyled, IconStyled, RootStyled } from './toasterBox.styles';

export default function ToasterBox(props) {
  const [showToast, setShowToast] = useState(false);
  const { showSeconds, message, setErrorSubmit } = props;

  useEffect(() => {
    let timerId;
    const timer = () => {
      setShowToast(true);
      timerId = setTimeout(() => {
        setShowToast(false);
        setErrorSubmit(false);
      }, showSeconds * 1000);
    };

    if (message) {
      timer();
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, []);

  const handleClick = () => {
    setShowToast(false);
    setErrorSubmit(false);
  };

  return (
    message && (
      <RootStyled>
        <ContentStyled showToast={showToast}>
          <Typography variant="body1">{message}</Typography>
          <IconStyled onClick={handleClick}>highlight_off</IconStyled>
        </ContentStyled>
      </RootStyled>
    )
  );
}

ToasterBox.propTypes = {
  showSeconds: PropTypes.number,
  message: PropTypes.string,
  setErrorSubmit: PropTypes.func,
};

ToasterBox.defaultProps = {
  showSeconds: 4,
  message: '',
  setErrorSubmit: () => {},
};
